import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import * as XLSX from "xlsx";
import Papa from "papaparse";
import axios from "axios";
import { Stepper, Step } from "react-form-stepper";
import StepWizard from "react-step-wizard";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import Select from "react-select";

let newArray;
let newOptions;
let dataFields = [];
let newUpdatedFields;
let fieldsNameOption = [];
let fields, excelReadData;
let afterReplacingFieldName;
const token = localStorage.getItem("Token");

const fieldReplace = () => {
  afterReplacingFieldName = newArray.map((object, index) => {
    return {
      [object.ID]: excelReadData[index].ID,
      [object.Accountnumber]: excelReadData[index].Accountnumber,
      [object.Address1]: excelReadData[index].Address1,
      [object.Address2]: excelReadData[index].Address2,
      [object.Balance]: excelReadData[index].Balance,
      [object.City]: excelReadData[index].City,
      [object.Comments]: excelReadData[index].Comments,
      [object.Companyname]: excelReadData[index].Companyname,
      [object.Country]: excelReadData[index].Country,
      [object.Defaulttermid]: excelReadData[index].Defaulttermid,
      [object.Email]: excelReadData[index].Email,
      [object.FirstName]: excelReadData[index].FirstName,
      [object.Internalnotes]: excelReadData[index].Internalnotes,
      [object.LastName]: excelReadData[index].LastName,
      [object.Overridedefaulttax]: excelReadData[index].Overridedefaulttax,
      [object.PhoneNumber]: excelReadData[index].PhoneNumber,
      [object.SelectImage]: excelReadData[index].SelectImage,
      [object.State]: excelReadData[index].State,
      [object.Taxclassid]: excelReadData[index].Taxclassid,
      [object.Terms]: excelReadData[index].Terms,
      [object.Zip]: excelReadData[index].Zip,
    };
  });
  console.log("afterReplacingFieldName: ", afterReplacingFieldName);
};

const ActionButtons = (props) => {
  const [loading, setloading] = useState(false);
  const handleBack = () => {
    props.previousStep();
    window.location.reload();
  };

  const handleNext = () => {
    if (props.currentStep === 1) {
      props.nextStep();
    }
    if (props.currentStep === 2) {
      for (let i = 0; i < newOptions.length; i++) {
        if (newOptions[i].isDisabled === false) {
          break;
        }
        if (newOptions.length - 1 === i) {
          fieldReplace();
          props.nextStep();
        }
      }
    }
  };

  // const handleFinish = () => {
  //     props.lastStep();
  // };

  return (
    <div className="text-center">
      {props.currentStep > 1 && (
        <button onClick={handleBack} className="btn btn-secondary me-3">
          Back
        </button>
      )}
      {props.currentStep < props.totalSteps && (
        <button onClick={handleNext} className="btn btn-primary">
          Next
        </button>
      )}
      {/* {props.currentStep === props.totalSteps && (
                <button onClick={handleFinish} className='btn btn-primary'>Finish</button>
            )} */}
    </div>
  );
};

const One = (props) => {
  const [fieldsName, setFieldsName] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios
      .get(`${config.suppliersBaseUrl}/suppliers/fieldnamesupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("supplier res.data.ResponseData: ", res.data.ResponseData);
        // console.log("data: ", data);
        setFieldsName(res.data.ResponseData);
        setLoading(false);
        dataFields = res.data.ResponseData;
        dataFields = [dataFields.map((obj) => obj.Field)];
        console.log("in res supplier dataFields: ", dataFields);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleExcelExportForAllSupplier = () => {
    setLoading(true);
    axios
      .post(
        `${config.suppliersBaseUrl}/suppliers/allsupplier`,
        {},
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);

        setLoading(false);
      });
  };

  const downloadExcel = () => {
    console.log("supplier dataFields: ", dataFields);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, dataFields);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const binaryData = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([binaryData], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "import_supplier.xlsx";
    link.click();
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryData = e.target.result;
      const workbook = XLSX.read(binaryData, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rawData = XLSX.utils.sheet_to_csv(sheet);

      const processedData = Papa.parse(rawData, {
        header: true,
        transformHeader: (header) => header.replace(/\s+|-|\/|#/g, ""),
      }).data;
      excelReadData = processedData;
      console.log(excelReadData,"excelReadData")

      const rows = rawData.split("\n");
      const data = rows.map((row) => row.split(","));
      fields = data[0];
    };

    reader.readAsBinaryString(file);

    axios
      .get(`${config.suppliersBaseUrl}/suppliers/fieldnamesupplier`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setFieldsName(res.data.ResponseData);
        setLoading(false);
        fieldsNameOption = res.data.ResponseData;
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="card card-background">
        <div className="card-body">
          {/* <span style={{ color: "red" }}>{error}</span> */}
          <h3 className="text-center">Download Spreadsheet Template</h3>
          <p className="text-center">
            For best results use our spreadsheet template which will include all
            records that are already in the system.
          </p>
          <div className="text-center">
            <button
              className="btn btn-primary me-3"
              onClick={handleExcelExportForAllSupplier}
            >
              Template for Existing Suppliers
            </button>
            <button className="btn btn-primary" onClick={downloadExcel}>
              Template for New Suppliers
            </button>
          </div>
          <br />
        </div>
      </div>
      <div className="card card-background">
        <div className="card-body">
          <h3 className="text-center">Upload File</h3>
          <p className="text-center">
            Upload a .xlsx or .csv Items Template with the updated information
          </p>
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <input
                type="file"
                className="form-control"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFile}
              />
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
      <ActionButtons {...props} />
    </>
  );
};

const Two = (props) => {
  const [loading, setLoading] = useState(false);
  const [selectedField, setSelectedField] = useState([]);
  const [fieldOption, setFieldOption] = useState([]);

  useEffect(() => {
    setFieldOption(
      fieldsNameOption.map((u) => {
        return { label: u.Field, value: u.Field };
        // return { label: u, value: u };
      })
    );
  }, [fieldsNameOption]);

  const handleFieldSelection = (e, index) => {
    selectedField[index] = e; // store selected option in array

    // regenerate options for disable selected options
    newOptions = fieldOption.map((tableFieldName) => {
      // store selected options status (true or false)
      let status = selectedField.map((selectField) => {
        return selectField.value.includes(tableFieldName.value);
      });

      return {
        ...tableFieldName,
        isDisabled: status.includes(true), // set disable option if status is true
      };
    });

    // set new options
    setFieldOption(newOptions);

    newArray = excelReadData.map((obj) => {
      return Object.keys(obj).reduce((acc, key, index) => {
        acc[key] = selectedField[index]?.value;
        return acc;
      }, {});
    });

    newUpdatedFields = newArray[0];

    const newExcelReadData = Object.entries(excelReadData).reduce(
      (obj, [key, value]) => {
        obj[newUpdatedFields[key] || key] = value;
        return obj;
      },
      {}
    );
    console.log("newOptions: ", newOptions);
    console.log("newExcelReadData: ", newExcelReadData);
  };

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  return (
    <>
      <Loader loading={loading} />
      <div className="card card-background">
        <div className="card-body">
          <h2 className="text-center">
            Match Spreadsheet Columns to the Database
          </h2>
          <p className="text-center">
            Select the database field that corresponds to each column. Click on
            next when you are finished matching the spreadsheet columns.
          </p>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table mb-0">
          <thead>
            <tr>
              <th>Spreadsheet Column</th>
              <th>Database Field</th>
            </tr>
          </thead>
          <tbody>
            {fields ? (
              <>
                {fields.map((data, index) => (
                  <tr key={index}>
                    <td className="text-center">{data}</td>
                    <td className="text-center">
                      <Select
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        isClearable={true}
                        onChange={(e) => {
                          handleFieldSelection(e, index);
                        }}
                        options={fieldOption}
                        placeholder="Select Field"
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={selectedField[index]}
                        id="FieldName"
                        name="FieldName"
                      />
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan={2} className="text-center">
                  Not found!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <br />
      <ActionButtons {...props} />
    </>
  );
};

const Three = (props) => {
  const [loading, setLoading] = useState(false);
  const [successMessageHideShow, setSuccessMessageHideShow] = useState(false);
  let navigate = useNavigate();

  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");

  const handleCompleteExcelImport = () => {
    console.log(excelReadData);

    let importData = {};

    importData.importDataXML = excelReadData;

    let importjsonstring = JSON.stringify(importData);

    console.log("importjsonstring:", importjsonstring);

    setLoading(true);
    axios
      .post(
        `${config.suppliersBaseUrl}/suppliers/importdata`,
        {
          xmlImportData: importjsonstring,
          loginUserId: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID == 1) {
          setSuccessMessageHideShow(true);
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/suppliers");
        } else {
          setSuccessMessageHideShow(false);
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);

        setLoading(false);
      });
  };

  return (
    <>

      <Loader loading={loading} />
      <div className="card card-background">
        <div className="card-body">
          <div className={`${successMessageHideShow == true ? "d-none" : ""}`}>
            <h3 className="text-center">Complete Excel Import</h3>
            <p className="text-center">
              Click "Complete Excel Import" to validate and complete the import.
            </p>
            <div className="text-center">
              <button
                className="btn btn-primary"
                onClick={handleCompleteExcelImport}
              >
                Complete Excel Import
              </button>
            </div>
          </div>
          <div className={`${successMessageHideShow == false ? "d-none" : ""}`}>
            <div
              className="alert alert-success alert-dismissible fade show text-center"
              role="alert"
            >
              <strong>Import Success!</strong> Your Items were imported without
              any errors.
            </div>
          </div>
        </div>
      </div>
      <ActionButtons {...props} />
    </>
  );
};

const ImportExcelSupplier = (props) => {
  const [loading, setLoading] = useState(false);
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const assignUser = (val) => {
    setUser((user) => ({
      ...user,
      ...val,
    }));
  };

  const handleStepChange = (e) => {
    setActiveStep(e.activeStep - 1);
  };

  const handleComplete = () => {
    alert("You r done. TQ");
  };

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div  className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}>
            <div className="row breadcrumb-position" >
              {/* <h3 className="page-title">Suppliers</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/suppliers">Supplier List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Import Supplier from Excel
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h6 className="card-title">
                  Mass import data from excel sheet
                </h6>
              </div>
              <div className="card-body">
                <div>
                  <Stepper activeStep={activeStep}>
                    <Step label="Upload File" />
                    <Step label="Match Spreadsheet to Database" />
                    <Step label="Validate Data and Complete Import" />
                  </Stepper>
                  {/* NOTE: IMPORTANT !! StepWizard must contains at least 2 children components, else got error */}
                  {/* <br /> */}
                  <StepWizard
                    instance={assignStepWizard}
                    onStepChange={handleStepChange}
                  >
                    <One userCallback={assignUser} />
                    <Two user={user} userCallback={assignUser} />
                    <Three user={user} completeCallback={handleComplete} />
                  </StepWizard>
                </div>
              </div>
              {/* end card body */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportExcelSupplier;
